import { LogoImg, NavButton } from 'components/Header/Header.styled';
import {
  HeaderSvgMobile,
  MobileBox,
  MobileContainer,
} from './MobileMenu.styled';
import close from 'images/sprite.svg';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import Logo from '../../../images/logo.png';
import { useTranslation } from 'react-i18next';
export const MobileMenu = ({ isOpen, toggleMenu, setIsOpen, footerRef }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const handleScrollToFooter = () => {
    if (footerRef?.current) {
      footerRef.current.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  if (isOpen) {
    document.addEventListener('keydown', e => {
      if (e.code === 'Escape') {
        setIsOpen(false);
      }
    });
    document.querySelector('body').style.overflow = 'hidden';
  } else {
    document.querySelector('body').style.overflow = 'visible';
  }

  return (
    <MobileContainer>
      <HeaderSvgMobile width="24" height="24" onClick={toggleMenu}>
        <use href={close + '#close'}></use>
      </HeaderSvgMobile>
      <LogoImg src={Logo} alt="logo" />

      {isOpen && (
        <MobileBox>
          <ul>
            <li>
              <NavLink
                className={`link ${location.pathname === '/' ? 'active' : ''}`}
                to="/"
                aria-label="Home"
                onClick={toggleMenu}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                className={`link ${location.pathname === '/' ? 'active' : ''}`}
                to="/menu"
                aria-label="Menu"
                onClick={toggleMenu}
              >
                {t('Speisekarte')}
              </NavLink>
            </li>
            <li>
              <NavButton
                onClick={handleScrollToFooter}
                aria-label="Contacts"
                className={`link ${location.pathname === '/' ? 'active' : ''}`}
              >
                {t('Kontakte')}
              </NavButton>
            </li>
          </ul>
        </MobileBox>
      )}
    </MobileContainer>
  );
};
